import { Chip } from '@mui/material';
import { forwardRef } from 'react';

const INVOICING_STATUS_COLORS = {
    PreInvoiced: 'success',
    Invoiced: 'success',
    Error: 'error',
    Abandoned: 'warning',
    Outdated: 'warning',
};

const INVOICING_STATUS_LABELS = {
    PreInvoiced: 'Pre-Invoiced',
    Invoiced: 'Invoiced',
    Error: 'Error',
    Abandoned: 'Abandoned',
    Outdated: 'Outdated',
};

const StatusPill = forwardRef(
    ({ content, variant = 'lt-admin-pill', status, sx, ...rest }, ref) => (
        <Chip
            ref={ref}
            variant={variant}
            label={INVOICING_STATUS_LABELS[status] || status}
            color={INVOICING_STATUS_COLORS[status] || 'default'}
            sx={{
                justifyContent: 'flex-start',
                minWidth: 105,
                '& .MuiChip-label': {
                    display: 'flex',
                    flexGrow: 1,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    rowGap: 2,
                },
                ...(sx || {}),
            }}
            {...rest}
        />
    )
);

export default StatusPill;
